import { GridPaginationModel, GridRowModel, GridSortModel } from '@mui/x-data-grid-pro'
import { Dispatch, SetStateAction } from 'react'

export const PAGE_SIZES = [10, 25, 100]
export const MIN_PAGE_SIZE = PAGE_SIZES[0]
export const MAX_PAGE_SIZE = PAGE_SIZES[PAGE_SIZES.length - 1]
const DEFAULT_PAGE_SIZE = PAGE_SIZES[0]

export interface ConfigurationTableSettings {
  rows: GridRowModel[]
  rowsCount: number
  gridLoading: boolean
  paginationModel: GridPaginationModel
  setPaginationModel: Dispatch<SetStateAction<GridPaginationModel>>
  sortModel?: GridSortModel
  setSortModel?: React.Dispatch<React.SetStateAction<GridSortModel>>
}

export interface ConfigurationTablePageSortSettings
  extends Pick<ConfigurationTableSettings, 'paginationModel' | 'setPaginationModel' | 'sortModel' | 'setSortModel'> {}

export interface ConfigurationGridDataSettings
  extends Pick<ConfigurationTableSettings, 'rows' | 'rowsCount' | 'gridLoading'> {}

export const DEFAULT_TABLE_SETTINGS: ConfigurationTableSettings = {
  rows: [],
  rowsCount: 0,
  gridLoading: true,
  setPaginationModel: () => {},
  paginationModel: { page: 0, pageSize: DEFAULT_PAGE_SIZE },
  sortModel: undefined,
  setSortModel: () => {},
}

export const DEFAULT_CONFIG_TABLE_PAGE_SORT_SETTINGS: ConfigurationTablePageSortSettings = {
  paginationModel: DEFAULT_TABLE_SETTINGS.paginationModel,
  setPaginationModel: DEFAULT_TABLE_SETTINGS.setPaginationModel,
  sortModel: DEFAULT_TABLE_SETTINGS.sortModel,
  setSortModel: DEFAULT_TABLE_SETTINGS.setSortModel,
}

export const DEFAULT_CONFIG_GRID_DATA_SETTINGS: ConfigurationGridDataSettings = {
  rows: DEFAULT_TABLE_SETTINGS.rows,
  rowsCount: DEFAULT_TABLE_SETTINGS.rowsCount,
  gridLoading: DEFAULT_TABLE_SETTINGS.gridLoading,
}
